export const advantages = [
  {
    title: '180万家',
    desc: '全球合作航司酒店高达180万家，覆盖全',
    image: '/images/pages/index/advantage-1.png',
  },
  {
    title: '2000+客户合作',
    desc: '行政事业单位、公检法、医疗系、教育系等',
    image: '/images/pages/index/advantage-2.png',
  },
  {
    title: '23年行业专注',
    desc: '23年服务上万家大型企业，引领行业发展',
    image: '/images/pages/index/advantage-3.png',
  },
  {
    title: '政府机票平台授权',
    desc: '获得国家“政府机票采购”平台授权，订票合规',
    image: '/images/pages/gp/advantage-4.png',
  },
]
